/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { putSystemAgentRoles } from '@/service/systemControl'
import AgentAssignRolesForm from './AgentAssignRolesForm'

class AgentAssignRolesModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    record: PropTypes.object.isRequired,
    baseProps: PropTypes.object,
    onSuccess: PropTypes.func,
    title: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  static defaultProps = {
    title: '分配角色',
    baseProps: {}
  }

  handleOk = async (formRef) => {
    const { onSuccess, record } = this.props
    const agentId = record?.id
    if (agentId == null) {
      message.error('缺少成员 id')
      throw new Error('缺少成员 id')
    }
    const fields = await formRef.current.validateFields()
    const raw = fields.roleIds
    const roleIds = Array.isArray(raw)
      ? raw.map((k) => {
          const n = Number(k)
          return Number.isNaN(n) ? k : n
        })
      : []
    const roleIdsStr = roleIds.map((id) => String(id)).join(',')
    const body = { roleIds: roleIdsStr }
    try {
      await putSystemAgentRoles(agentId, body)
      message.success('角色已更新')
      if (typeof onSuccess === 'function') {
        onSuccess()
      }
    } catch (e) {
      const msg =
        e?.response?.data?.msg ||
        e?.response?.data?.message ||
        e?.message ||
        e?.msg ||
        '保存失败'
      message.error(typeof msg === 'string' ? msg : '保存失败')
      throw e
    }
  }

  render() {
    const { children, baseProps, title, width: widthProp, record } = this.props
    const width = widthProp !== undefined ? widthProp : 720

    return (
      <WrappedModal
        children={children}
        title={title}
        width={width}
        destroyOnClose
        baseComponent={<AgentAssignRolesForm />}
        baseProps={{
          ...baseProps,
          record
        }}
        onOk={this.handleOk}
        okText="保存"
      />
    )
  }
}

export default AgentAssignRolesModal
